<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Excel Sample
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.model_name"
                outlined
                label="Module"
                prepend-inner-icon="mdi-card-text-outline"
                @input="form.model_name = form.model_name.toUpperCase()"
                :error-messages="errors.model_name"
              ></v-text-field>
            </v-col>
            <v-col>
              <input
                type="file"
                id="document"
                name="document"
                ref="document"
                accept=".xls,.xlsx"
                @input="handleFileUpload"
              />
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Excel Sample
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "ExcelSampleCreatePage",
  data() {
    return {
      form: {
        model_name: "",
      },
      excelSample: [],
      user: {
        branch: {
          state: {},
        },
      },
      isDeleteInstallmentDialogs: [],
      userItems: [],
      isLoading: false,
    };
  },
  mounted() {
    // this.getMasters();
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.excelSample = await axios.post("/samples", this.form);
        await this.handleFileUpload();
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        // this.$router.push("/samples");
        this.$router.back();
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      let formData = new FormData();
      this.document_attachment = this.$refs.document.files[0];
      const formattedFilename =
        this.excelSample.data.data.model_name
          .toLowerCase()
          .replace(/\s+/g, "_") + "_";
      formData.append("id", this.excelSample.data.data.id);
      formData.append("filename", formattedFilename);
      formData.append("document", this.document_attachment);
      console.log("formData", formData);
      await axios
        .post("upload_excel_sample_documents", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
      this.isUploading = false;
    },
  },
};
</script>
